import React from "react";
import { map, find } from "lodash";

import { dFlex, dFlexC, flex1, fontFamily } from "./styles";
import { moneyFormat } from "./format";
import OnePanel from "./OnePanel";
import Text from "./Text";

import AbbreviatedMillionNumberFormat from "../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

const tdStyle = {
  padding: ".8em",
  border: "solid #000000 1px",
  background: "#FFFFFF",
  borderBottom: "hidden"
};

const tdLeft = {
  ...tdStyle,
  borderRight: "hidden"
};

const tdRight = {
  ...tdStyle,
  borderLeft: "hidden"
};

const tdMiddle = {
  ...tdStyle,
  borderRight: "hidden",
  borderLeft: "hidden"
};

const tdPadding = "10px";

const DiffTable = ({ tables }) => (
  <div>
    {map(tables, (table, idx) => (
      <div
        key={idx}
        style={{
          backgroundColor: "#FFFFFF",
          padding: "2em",
          boxShadow: "0 4px 8px rgba(0, 0, 0, .15)",
          marginTop: idx > 0 ? "20px" : 0,
          fontFamily
        }}
      >
        <div
          style={{
            fontSize: "12px",
            color: "rgba(58, 58, 58, 0.8)",
            textAlign: "center",
            marginTop: "-15px"
          }}
        >
          M = Millions
        </div>
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold"
          }}
        >
          {table.title}
        </div>
        <table
          style={{
            border: "none",
            marginBottom: "1em",
            width: "100%",
            color: "#3a3a3a"
          }}
        >
          <tbody style={{}}>
            <tr style={{}}>
              <td
                style={{
                  ...tdLeft,
                  border: "none",
                  paddingTop: tdPadding,
                  paddingBottom: tdPadding
                }}
              ></td>
              <td
                style={{
                  ...tdMiddle,
                  border: "none",
                  color: "#3a3a3a",
                  textAlign: "center",
                  fontSize: "14px",
                  paddingTop: tdPadding,
                  paddingBottom: tdPadding,
                  borderRight: "1px solid #e0e0e0"
                }}
              >
                Expected
              </td>
              <td
                style={{
                  ...tdMiddle,
                  color: "#3a3a3a",
                  border: "none",
                  textAlign: "center",
                  fontSize: "14px",
                  paddingTop: tdPadding,
                  paddingBottom: tdPadding,
                  borderLeft: "1px solid #e0e0e0",
                  borderRight: "1px solid #e0e0e0"
                }}
              >
                Actual
              </td>
              <td
                style={{
                  ...tdRight,
                  color: "#3a3a3a",
                  border: "none",
                  textAlign: "center",
                  fontSize: "14px",
                  paddingTop: tdPadding,
                  paddingBottom: tdPadding,
                  borderLeft: "1px solid #e0e0e0"
                }}
              >
                Diff
              </td>
            </tr>
            {map(table.data, (row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tdLeft,
                    color: "#3a3a3a",
                    border: "none",
                    fontSize: "14px",
                    textAlign: "right",
                    width: "150px",
                    paddingTop: tdPadding,
                    paddingBottom: tdPadding
                  }}
                >
                  {row[0]}
                </td>
                <td
                  style={{
                    ...tdMiddle,
                    color: index === table.data.length - 1 ? "#fff" : "#3a3a3a",
                    border: "none",
                    fontSize: "16px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: tdPadding,
                    paddingBottom: tdPadding,
                    borderRight: "1px solid #e0e0e0"
                  }}
                >
                  <span
                    style={
                      index === table.data.length - 1
                        ? {
                          backgroundColor: "#52c5cd",
                          display: "inline-block",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          minWidth: "85px"
                        }
                        : row[0] === "Total Cost of Sales"
                          ? {
                            backgroundColor: "rgba(82, 197, 205, 0.3)",
                            display: "inline-block",
                            paddingLeft: "5px",
                            paddingRight: "5px",
                            minWidth: "85px"
                          }
                          : {}
                    }
                  >
                    <AbbreviatedMillionNumberFormat
                      value={row[1]}
                      prefix={row[4]}
                      decimalPrecision={row[5]}
                      forceConvert={row[6]}
                    />
                  </span>
                </td>
                <td
                  style={{
                    ...tdMiddle,
                    color: index === table.data.length - 1 ? "#fff" : "#383838",
                    border: "none",
                    fontSize: "16px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: tdPadding,
                    paddingBottom: tdPadding,
                    borderLeft: "1px solid #e0e0e0",
                    borderRight: "1px solid #e0e0e0"
                  }}
                >
                  <span
                    style={
                      index === table.data.length - 1
                        ? {
                          backgroundColor: "#52c5cd",
                          display: "inline-block",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          minWidth: "85px"
                        }
                        : row[0] === "Total Cost of Sales"
                          ? {
                            backgroundColor: "rgba(82, 197, 205, 0.3)",
                            display: "inline-block",
                            paddingLeft: "5px",
                            paddingRight: "5px",
                            minWidth: "85px"
                          }
                          : {}
                    }
                  >
                    <AbbreviatedMillionNumberFormat
                      value={row[2]}
                      prefix={row[4]}
                      decimalPrecision={row[5]}
                      forceConvert={row[6]}
                    />
                  </span>
                </td>
                <td
                  style={{
                    ...tdRight,
                    color: row[3] < 0 ? "#ff0000" : "#383838",
                    border: "none",
                    fontSize: "16px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: tdPadding,
                    paddingBottom: tdPadding,
                    borderLeft: "1px solid #e0e0e0"
                  }}
                >
                  {row[3]}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ))}
  </div>
);

function getDataValue(data, round, field, is_actual, roundId) {
  const row = data.find(
    i =>
      i.target_round_number === round &&
      i.is_actual === is_actual &&
      i.round === roundId
  );

  if (row && field in row) {
    return row[field];
  }

  return 0;
}

function getExpected(data, round, field, roundId) {
  return getDataValue(data, round, field, false, roundId);
}

function getActual(data, round, field, roundId) {
  return getDataValue(data, round, field, true, roundId);
}

function getDiff(expected, actual) {
  if (expected === 0 || actual === 0) {
    return 0;
  }

  return Number((((actual - expected) / Math.abs(expected)) * 100).toFixed(2));
}

function getRevenues(round, roundId, data) {
  const unitsExpected = Math.abs(
    getExpected(data, round, "units_sold", roundId)
  );
  const unitsActual = Math.abs(getActual(data, round, "units_sold", roundId));
  const unitsDiff = getDiff(unitsExpected, unitsActual);

  const avgSellingPriceExpected = getExpected(
    data,
    round,
    "average_selling_price",
    roundId
  );
  const avgSellingPriceActual = getActual(
    data,
    round,
    "average_selling_price",
    roundId
  );
  const avgSellingPriceDiff = getDiff(
    avgSellingPriceExpected,
    avgSellingPriceActual
  );

  const totalRevenuesExpected = getExpected(
    data,
    round,
    "total_revenues",
    roundId
  );
  const totalRevenuesActual = getActual(data, round, "total_revenues", roundId);
  const totalRevenuesDiff = getDiff(totalRevenuesExpected, totalRevenuesActual);

  return [
    ["Units", unitsExpected, unitsActual, unitsDiff, "", 0, false],
    [
      "Avg. Selling Price",
      avgSellingPriceExpected,
      avgSellingPriceActual,
      avgSellingPriceDiff,
      "$",
      2,
      false
    ],
    [
      "Total Revenues",
      totalRevenuesExpected,
      totalRevenuesActual,
      totalRevenuesDiff,
      "$",
      2,
      true
    ]
  ];
}

function getGrossProfits(round, roundId, data) {
  const unitsExpected = Math.abs(
    getExpected(data, round, "units_sold", roundId)
  );
  const unitsActual = Math.abs(getActual(data, round, "units_sold", roundId));
  const unitsDiff = getDiff(unitsExpected, unitsActual);

  const avgUnitCostsExpected = getExpected(
    data,
    round,
    "average_unit_costs",
    roundId
  );
  const avgUnitCostsActual = getActual(
    data,
    round,
    "average_unit_costs",
    roundId
  );
  const avgUnitCostsDiff = getDiff(avgUnitCostsExpected, avgUnitCostsActual);

  const totalCostOfSalesExpected = getExpected(
    data,
    round,
    "total_cost_goods_sold",
    roundId
  );
  const totalCostOfSalesActual = getActual(
    data,
    round,
    "total_cost_goods_sold",
    roundId
  );
  const totalCostOfSalesDiff = getDiff(
    totalCostOfSalesExpected,
    totalCostOfSalesActual
  );

  const grossProfitsExpected = getExpected(
    data,
    round,
    "gross_profits",
    roundId
  );
  const grossProfitsActual = getActual(data, round, "gross_profits", roundId);
  const grossProfitsDiff = getDiff(grossProfitsExpected, grossProfitsActual);

  return [
    ["Units", unitsExpected, unitsActual, unitsDiff, "", 0, false],
    [
      "Avg. Units Costs",
      avgUnitCostsExpected,
      avgUnitCostsActual,
      avgUnitCostsDiff,
      "$",
      2,
      false
    ],
    [
      "Total Cost of Sales",
      totalCostOfSalesExpected,
      totalCostOfSalesActual,
      totalCostOfSalesDiff,
      "$",
      2,
      true
    ],
    [
      "Gross Profits",
      grossProfitsExpected,
      grossProfitsActual,
      grossProfitsDiff,
      "$",
      2,
      true
    ]
  ];
}

function getNetProfits(round, roundId, data, incomeStatement) {

  const expensesExpected =
    getExpected(data, round, "total_operating_costs", roundId) +
    getExpected(data, round, "total_non_operating_costs", roundId);
  const expensesActual =
    getActual(data, round, "total_operating_costs", roundId) +
    getActual(data, round, "total_non_operating_costs", roundId);
  const expensesDiff = getDiff(expensesExpected, expensesActual);

  const grossIncomeExpected = getExpected(
    data,
    round,
    "income_before_taxes",
    roundId
  );
  const grossIncomeActual = getActual(
    data,
    round,
    "income_before_taxes",
    roundId
  );
  const grossIncomeDiff = getDiff(grossIncomeExpected, grossIncomeActual);

  const netProfitsExpected = getExpected(data, round, "net_income", roundId);
  const netProfitsActual = incomeStatement['Net Income'];
  const netProfitsDiff = getDiff(netProfitsExpected, netProfitsActual);

  return [
    ["Expenses", expensesExpected, expensesActual, expensesDiff, "$", 2, true],
    [
      "Income Before Taxes",
      grossIncomeExpected,
      grossIncomeActual,
      grossIncomeDiff,
      "$",
      2,
      true
    ],
    [
      "Net Profits",
      netProfitsExpected,
      netProfitsActual,
      netProfitsDiff,
      "$",
      2,
      true
    ]
  ];
}

const FPAIncomeStatement = ({
  round,
  teamId,
  teams,
  incomeStatement,
  financialAnalysis,
  rounds
}) => {
  const roundObj = rounds.find(r => r.number === round);
  const roundId = roundObj ? roundObj.id : 0;
  const teamName = find(teams, team => team["id"] === teamId).name;

  return (
    <div style={dFlex}>
      <OnePanel title="Income Statement" style={flex1}>
        <Text>
          The FP&amp;A (to the right) is comparing your expected vs. actual
          Income Statement.
          <br />
          <br />
          In this round, your CEO expected Team {teamName} to generate net
          profits of {moneyFormat(financialAnalysis.net_income)}, but Team{" "}
          {teamName} actually generated net profits of{" "}
          {moneyFormat(incomeStatement["Net Income"])}.<br />
          <br />
          Was your expectation too bullish or bearish?
        </Text>
      </OnePanel>
      <div style={{ ...flex1, ...dFlexC, marginLeft: "2em" }}>
        <DiffTable
          tables={[
            {
              title: "Revenues",
              data: getRevenues(round, roundId, financialAnalysis)
            },
            {
              title: "Gross Profits",
              data: getGrossProfits(round, roundId, financialAnalysis),
            },
            {
              title: "Net Profits",
              data: getNetProfits(round, roundId, financialAnalysis, incomeStatement)
            }
          ]}
        />
      </div>
    </div>
  );
};

export default FPAIncomeStatement;



// WEBPACK FOOTER //
// ./src/components/analysis/FPAIncomeStatement.js